import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Checkbox from '../Checkbox/index.js';
import Columnizer from '../Columnizer/index.js';
import CheckboxWithVisual from '../CheckboxWithVisual/index.js';

/**
 *  CheckboxGroup generates a group of checkbox elements that will fire a supplied callback when interacted with.
 *
 */
const CheckboxGroup = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    options = [],
    buttons,
    columnClasses,
    columns,
    hasVisual,
    withCheckmark = false,
    labelClassName,
    type = 'stacked',
    onChange = () => {},
    value = [],
    ...rest
  } = _ref;
  const isStacked = type === 'stacked';
  const checkboxes = options.map(option => {
    const checked = value.includes(option.value);
    const labelClasses = clsx(labelClassName, {
      'btn btn-default checkbox-btn': buttons,
      'checkbox-inline': !isStacked && !columnClasses,
      active: buttons && checked
    });
    delete option.isFiltersCollapsed;
    delete option.moreInfo;
    delete option.filterBadge;
    return hasVisual ? /*#__PURE__*/React.createElement(CheckboxWithVisual, Object.assign({
      ref: ref,
      key: option.value,
      checked: checked,
      onChange: onChange,
      multiple: true,
      src: option.src,
      colorValue: option.colorValue,
      withCheckmark: withCheckmark,
      labelClassName: labelClasses
    }, option, rest)) : /*#__PURE__*/React.createElement(Checkbox, Object.assign({
      ref: ref,
      key: option.value,
      checked: checked,
      onChange: onChange,
      multiple: true,
      labelClassName: labelClasses
    }, option));
  });
  const columnize = items => /*#__PURE__*/_jsx(Columnizer, {
    items: items,
    columns: columns,
    columnClasses: columnClasses
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "checkboxGroup",
    className: clsx({
      'checkbox-group': true,
      row: hasVisual
    })
  }, rest), columns ? columnize(checkboxes) : checkboxes);
});
export default CheckboxGroup;